import PageLayout from '../components/PageLayout';
import ErrorWrapper from '../components/errors/ErrorWrapper';
import Routes from '../components/routes/PortalRoutes';
import useCallObject from '../hooks/useCallObject';
import useRecurringMeetings from '../hooks/useRecurringMeetings';
import useTrackerInfoListener from '../hooks/useTrackerInfoListener';
import { jsx as _jsx } from "react/jsx-runtime";
function Portal() {
  useTrackerInfoListener();
  useRecurringMeetings();
  useCallObject();
  return /*#__PURE__*/_jsx(PageLayout, {
    children: /*#__PURE__*/_jsx(ErrorWrapper, {
      children: /*#__PURE__*/_jsx(Routes, {})
    })
  });
}
export default Portal;